import { QuotationDetails } from '../../components/quotation-editor/quotation-details/QuotationDetails';
import { QuotationSellerDetails } from '../../components/quotation-editor/quotation-seller-details/QuotationSellerDetails';
import { QuotationBuyerDetails } from '../../components/quotation-editor/quotation-buyer-details/QuotationBuyerDetails';
import { QuotationProducts } from '../../components/quotation-editor/quotation-products/QuotationProducts';
import { QuotationSummary } from '../../components/quotation-editor/quotation-summary/QuotationSummary';
import { QuotationCustomItems } from 'components/quotation-editor/quotation-custom-items/QuotationCustomItems';

export const QUOTATION_ACCORDION_CONTENT = [
    {
        id: 'quotation_details',
        title: 'QUOTATION_DETAILS',
        component: QuotationDetails,
    },
    {
        id: 'quotation_giving_details',
        title: 'QUOTATION_GIVING_DETAILS',
        component: QuotationSellerDetails,
    },
    {
        id: 'quotation_customer',
        title: 'QUOTATION_CUSTOMER',
        component: QuotationBuyerDetails,
    },
    {
        id: 'quotation_products',
        title: 'QUOTATION_PRODUCTS',
        component: QuotationProducts,
    },
    {
        id: 'quotation_custom_items',
        title: 'QUOTATION_CUSTOM_ITEMS',
        component: QuotationCustomItems,
    },
    {
        id: 'quotation_summary',
        title: 'QUOTATION_SUMMARY',
        component: QuotationSummary,
    },
];
